// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"8021d221","15":"02cd4f25","123":"c11d770d","232":"02900505","485":"52321a99","513":"d4721086","523":"efdb5d1b","787":"0065cc43","804":"f6acaa40"}[chunkId] + ".chunk.js";
};